// Centraliserad CTA-hierarki (Fas B — strategirapporten).
//
// En enda sanningskälla för sajtens primära/sekundära/tertiära CTA:er så att
// copy, mål-route och tracking-id aldrig driftar isär mellan sidor. Använd
// dessa i stället för att hårdkoda etiketter och länkar i varje komponent.
//
// Hierarki (uppdaterad enligt strategirapporten, Fas B):
//   Primär   — "Boka strategimöte"      → /kontakt          (varma besökare)
//   Sekundär — "Se priser"              → /priser
//   Kall-CTA — "Testa med ett Pilot"    → /pilot            (kalla besökare)
//   Tertiär  — "Räkna ut ert pris"      → /film-pris-kalkyl (behålls tillgänglig
//              men används inte längre som primär hero-CTA).

import type { CtaId } from "@/lib/analytics";

export interface CtaDef {
  label: string;
  to: string;
  trackId: CtaId;
}

export const CTA = {
  /** Primär CTA — boka kostnadsfritt strategimöte (varma besökare). */
  bookMeeting: {
    label: "Boka strategimöte",
    to: "/kontakt",
    trackId: "book_strategy_meeting",
  },
  /** Sekundär CTA — prislista. */
  pricing: {
    label: "Se priser",
    to: "/priser",
    trackId: "view_pricing",
  },
  /** Kall-CTA — lågtröskel-ingång via Pilot, default för kalla besökare. */
  pilot: {
    label: "Testa med ett Pilot",
    to: "/pilot",
    trackId: "book_pilot",
  },
  /** Tertiär — interaktiv prisberäknare. Behålls, men inte primär längre. */
  priceFinder: {
    label: "Räkna ut ert pris",
    to: "/film-pris-kalkyl",
    trackId: "open_price_finder",
  },
} satisfies Record<string, CtaDef>;

export type CtaKey = keyof typeof CTA;
